import { get, post } from '@/request/request'

export default {
    list(params) {
        return get('/admin/check/io/list', params)
    },
    add(params) {
        return post('/admin/check/io/add',params)
    },

}